
<mat-dialog-content>
    <h2><strong>Quantidade de obras</strong></h2>
    <p class="pt-3">Você precisa selecionar <strong>ao menos 05 obras</strong>, que deverão ser 
        lidas obrigatoriamente por todos os alunos da turma.</p>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center" class="mt-2 mb-1">
    <button mat-raised-button mat-dialog-close tabindex="-1" color="primary">Retornar à seleção</button>
</mat-dialog-actions>